import { Col, Modal, Row } from "antd";
import { MazakaButton } from "apps/Common/MazakaButton";
import { DeleteOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import MessageList from "./MessageList";
import SendMessage from "./SendMesssage";
import { useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import NoSelectedUserMessage from "./NoSelectedUserMessage";
import MessageDetailOptions from "./MessageDetailOptions";
import AdvertInfoes from "./AdvertInfoes";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import { deleteAllMessages } from "../../Services";
import Search from "./Search";
import { useQueryClient } from "react-query";
import messageEndpoint from "../../EndPoints"

const MessageDetails = () => {
  const { messageDetilsFilter, messageDetailsListData } = useSelector(
    (state: RootState) => state.message
  );
  const { userInfoes } = useSelector((state: RootState) => state.profile)

  const queryClient = useQueryClient()

  const handleDeleteAllMessages = async () => {
    try {

      await deleteAllMessages({
        advertId: messageDetilsFilter.AdvertId,
        contactId: messageDetilsFilter.ContactUserId,
        isDeletedByContact: userInfoes.id === messageDetailsListData?.advertUserId ? false : true
      });
      queryClient.resetQueries({
        queryKey: messageEndpoint.getMessageGroupDetail,
        exact: false,
      });


      openNotificationWithIcon("default", "Mesajlar başarıyla silindi");
    } catch (error: any) {
      openNotificationWithIcon("default", error?.message);
      console.log("Somethings wrong during delete messges", error);
    }
  };
  const confirmDeleteAllMessage = () => {
    Modal.confirm({
      title: "Uyarı",
      icon: <ExclamationCircleOutlined />,
      content: `Tüm mesajlar silinecek.Onaylıyor musunuz?`,
      okText: "Devam Et",

      cancelText: "Vazgeç",
      onOk: async () => {
        handleDeleteAllMessages()

      },
    });
  };

  return (
    <Row>
      {messageDetilsFilter?.ContactUserId && messageDetilsFilter.AdvertId ? (
        <>
          <Col xs={24} className=" !shadow-md  ">
            <Row className="  !bg-[#f5f5f5] !p-3 md:!p-6 ">
              <Col xs={24} lg={18}>
                <AdvertInfoes />
              </Col>
              <Col xs={24} lg={6} className="!flex gap-4" >
                <div className="!w-[70px] !h-[70px] " >

                </div>
                <MessageDetailOptions />
              </Col>
            </Row>
          </Col>

          <Col xs={24} className=" !bg-[#e6eaea] !p-3 md:!p-6   ">
            <Row gutter={[0, 40]} className="!h-full">
              <>
                <Col xs={24} className="!h-[8%]">
                  <Row gutter={[0, 10]}>
                    <Col xs={24} lg={12}>
                      <Row>
                        <Col xs={24} lg={12} className="!hidden lg:!block" >
                          {/* <Search /> */}
                          <Search contactId={messageDetilsFilter.ContactUserId} advertId={messageDetilsFilter.AdvertId} />

                        </Col>
                      </Row>
                    </Col>
                    <Col xs={24} lg={12} className="!flex justify-end ">
                      <MazakaButton
                        className="md:!text-red-500 md:hover:!text-white md:hover:!bg-red-500 !text-xs md:!text-sm md:!bg-transparent !bg-red-500 !text-white"
                        icon={<DeleteOutlined />}
                        onClick={confirmDeleteAllMessage}
                        type="text"
                      >
                        Bu İlana ait tüm mesajları sil
                      </MazakaButton>
                    </Col>
                  </Row>
                </Col>
                <Col xs={24}
                  className="md:!max-h-[1000px] !h-[400px]  !overflow-auto !mt-6 md:mt-0">
                  <MessageList />
                </Col>
                <Col xs={24} className="!flex items-end md:!h-[8%]">
                  <SendMessage />
                </Col>
              </>
            </Row>
          </Col>
        </>
      ) : (
        <>
          <Col xs={24} className="!h-screen flex items-center !justify-center">
            <NoSelectedUserMessage />
          </Col>
        </>
      )}
    </Row>
  );
};

export default MessageDetails;
